<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<div class="alignment-block alignment-block-align-right">
<p class="alignment-block-content alignment-block-content-right">Yes, yours, my love, is the right human <span class="last-word">face</span>.</p>
<p class="alignment-block-content alignment-block-content-right">I in my mind had waited for this <span class="last-word">long</span>,</p>
<p class="alignment-block-content alignment-block-content-right">Seeing the false and searching for the <span class="last-word">true</span>,</p>
<p class="alignment-block-content alignment-block-content-right">Then found you as a traveller finds a <span class="last-word">place</span></p>
<p class="alignment-block-content alignment-block-content-right">Of welcome suddenly amid the <span class="last-word">wrong</span></p>
<p class="alignment-block-content alignment-block-content-right">Valleys and rocks and twisting roads. But <span class="last-word">you</span>,</p>
<p class="alignment-block-content alignment-block-content-right">What shall I call you? A fountain in a <span class="last-word">waste</span>,</p>
<p class="alignment-block-content alignment-block-content-right">A well of water in a country <span class="last-word">dry</span>,</p>
<p class="alignment-block-content alignment-block-content-right">Or anything that’s honest and good, an <span class="last-word">eye</span></p>
<p class="alignment-block-content alignment-block-content-right">That makes the whole world bright. Your open <span class="last-word">heart</span>,</p>
<p class="alignment-block-content alignment-block-content-right">Simple with giving, gives the primal <span class="last-word">deed</span>,</p>
<p class="alignment-block-content alignment-block-content-right">The first good world, the blossom, the blowing <span class="last-word">seed</span>,</p>
<p class="alignment-block-content alignment-block-content-right">The hearth, the steadfast land, the wandering <span class="last-word">sea</span>,</p>
<p class="alignment-block-content alignment-block-content-right">Not beautiful or rare in every <span class="last-word">part</span>,</p>
<p class="alignment-block-content alignment-block-content-right">But like yourself, as they were meant to <span class="last-word">be</span>.</p>
</div>
<div class="alignment-block alignment-block-align-right">
<p class="alignment-block-content alignment-block-content-right">THE CONFIRMATION by Edwin <span class="last-word">Muir</span></p>
<p class="alignment-block-content alignment-block-content-right">15 May 1887 – 3 January <span class="last-word">1959</span></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?28d9dcb9